import { AuthEnums } from "@/enums/Enums";
import { MeetDetailPayload, MeetState } from "@/interfaces/IApp";
import { jwtDecode } from "jwt-decode";
import type { StateCreator } from "zustand";
import type { AppStore } from "../appStore";

export interface MeetSlice extends MeetState {
  setMeetDetail: (payload: MeetDetailPayload) => void;
  setGuestDisplayName: (displayName: string) => void;
  resetMeetDetail: () => void;
}

const initialState: MeetState = {
  meet: {
    token: null,
    info: null,
    mode: "select",
    displayName: null,
  },
};

export const createMeetSlice: StateCreator<AppStore, [], [], MeetSlice> = (
  set,
  get
) => ({
  ...initialState,

  setMeetDetail: ({ token, mode }) => {
    let info = null;

    try {
      if (token && token.length > 0) {
        info = jwtDecode(token);
      }
    } catch (error) {
      info = null;
    }

    set((state) => ({
      meet: {
        ...state.meet,
        mode,
        token,
        info,
      },
    }));
  },

  setGuestDisplayName: (displayName) => {
    const { meet } = get();

    if (meet.mode !== AuthEnums.EnterName) return;

    set((state) => ({
      meet: {
        ...state.meet,
        displayName,
        mode:
          displayName && displayName.length > 0
            ? AuthEnums.Guest
            : state.meet.mode,
      },
    }));
  },

  resetMeetDetail: () => {
    set({
      meet: initialState.meet,
    });
  },
});
